module.exports = __webpack_public_path__ + "img/subscribe-mobile.1ac1184d.svg";